import React from 'react';
import { Empty, Table, Button, Flex, message, Modal } from 'antd';
import OrderCard from './card';
import TimesCard from '../promotion/goods-card/card';
import dayjs from 'dayjs';
import LogisticsDetail from './logistics-detail';

const { Column } = Table;

export default () => {
    const params = new URLSearchParams(window.location.search);
    const shopId = params.get('shopId');
    const parentOrderId = params.get('parentOrderId');

    const [item, setItem] = React.useState(null);
    const { refundStatus } = item || {};

    React.useEffect(() => {
        console.log('parentOrderId', parentOrderId, shopId);
        if(parentOrderId && shopId) {
            loadOrderDetail();
        }
    }, []);

    const getOrderDetail = async (params) => {
        const res = await fetch(`/api/order/detail?${new URLSearchParams(params)}`);
        const result = await res.json();
        return result;
    }

    const loadOrderDetail = () => {
        getOrderDetail({parentOrderId, shopId}).then(res => {
            setItem(res.data);
        })
    }

    const handleRefund = (type) => {
        const text = type === 'refuse' ? '拒绝' : '同意';
        Modal.confirm({
            title: `确认${text}退款`,
            // okText: '确认',
            // cancelText: '取消',
            onOk: async () => {
                refund(type);
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            }
        })
    }

    const refund = async (type) => { 
        const response = await fetch('/api/order/refund', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                parentOrderId,
                type,
                shopId
            })
        });

        const res = await response.json();

        if(res && res.success) {
            message.success('操作成功');
        } else {
            message.error('退款失败');
        }
    }

    return (
        <div>
            <h2 className="admin-page-title">订单详情</h2>
            {
                item ? <OrderCard detail={true} onFlowChange={loadOrderDetail} content={item} className="w-full min-w-[360px] max-w-[456px] mb-4" /> : <Empty />
            }
            <div>
                {
                    refundStatus === 3 && <div className="flex gap-2">
                        <Button onClick={() => handleRefund('agree')}>同意退款</Button>
                        <Button onClick={() => handleRefund('refuse')}>拒绝退款</Button>
                    </div>
                }
            </div>
            {
                item?.timesCard && <div>
                    <h3 className="admin-section-title">次卡信息</h3>
                    <TimesCard content={item.timesCard} />
                </div>
            }
            <h3 className="admin-section-title">支付记录</h3>
            {
                item?.pays?.length ? <Table dataSource={item.pays} pagination={false} size="small">
                    <Column title="支付时间" dataIndex="payTime" render={(text) => dayjs(text).format('YYYY-MM-DD HH:mm:ss')} />
                    <Column title="支付金额" dataIndex="amount" render={(text) => <>{text/100} 元</>} />
                    <Column title="详情" render={(text, record) => <a href={`/pay/detail?payId=${record.payId}`}>查看</a>} />
                </Table>
                : <Empty />
            }
            { item?.goodsType === 'GOODS' && 
                <>
                    <h3 className="admin-section-title">物流信息</h3>
                    <LogisticsDetail parentOrderId={parentOrderId} />
                </>
            }
        </div>
    )
}